export default __webpack_public_path__ + "static/media/whatsapp-circle-300x300.24a3f737.png";